import React from "react";

const ContactUs = () => {
  return (
    <section className="bg-gradient-to-br from-blue-50 to-indigo-50 py-8 px-4 rounded-lg">
      <div className="max-w-sm mx-auto">
        {/* Header */}
        <div className="text-center mb-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-1">Contact Us</h2>
          <p className="text-gray-600 text-sm">
            Send us a message and we'll respond as soon as possible.
          </p>
        </div>

        {/* Form */}
        <form className="space-y-3 bg-white p-5 rounded-lg shadow-lg">
          {/* Name Input */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Your Name</label>
            <input
              type="text"
              placeholder="Enter your full name"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
            />
          </div>

          {/* Email Input */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Your Email</label>
            <input
              type="email"
              placeholder="Enter your email address"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition"
            />
          </div>

          {/* Message Input */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-1">Your Message</label>
            <textarea
              placeholder="Tell us how we can help you..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition h-28 resize-none"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold py-2 rounded-lg hover:from-blue-600 hover:to-blue-700 transition transform hover:scale-105 shadow-md"
          >
            Send Message
          </button>
        </form>

        {/* Alternative Contact Info */}
        <div className="mt-4 text-center">
          <p className="text-gray-600 text-xs">
            Or email us at <span className="font-semibold text-blue-600">connect@7hillslab.com</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;